// extracted by mini-css-extract-plugin
export default {"contact":"EntryForm_contact__IcYVN","contactLabel":"EntryForm_contactLabel__CULVS","contactLink":"EntryForm_contactLink__jjGYe"};